import ProductosScreen from "../../Screen/ERP/Global/Productos/ProductosScreen";
import CategoriasScreeen from '../../Screen/ERP/Suministros/Categorias/CategoriasScreen'
import SubCategoriasScreen from "../../Screen/ERP/Suministros/SubCategorias/SubCategoriasScreen";
import TipoProductoScreen from "../../Screen/ERP/Suministros/TipoProdcuto/TipoProductoScreen";
import VehiculosScreen from "../../Screen/ERP/Global/Vehiculos/VehiculosScreen";
import MotoristasScreen from "../../Screen/ERP/Global/Motoristas/MotoristasScreen";

import CurrencyScreen from "../../Base/Screens/Global/Currency/CurrencyScreen";
import UnitScreen from "../../Base/Screens/Global/UnidadMedida/UnitScreen"
import CountriesScreen from "../../Base/Screens/Global/Countries/CounstriesScreen";
import TypesScreen from "../../Base/Screens/Global/Types/TypeScreen";
import PrioridadesScreen from "../../Base/Screens/Global/Prioridades/PrioridadesScreen"
// import AreasScreen from "../../Base/Screens/Global/Areas/AreasScreen";
import PermisosGeneralesScreen from "../../Base/Screens/Global/PermisosGenerales/PermisosGeneralesScreen";
import TabAreasScreen from "../../Screen/ERP/Global/Areas/TabAreasScreen";

export const GlobalRouter = [
  {
    path: "Global/Productos",
    permiso: 10,
    element: <ProductosScreen IdType = {35}/>,
  },
  {
    path: "Global/Categorias",
    permiso: 11,
    element: <CategoriasScreeen />,
  },
  {
    path: "Global/SubCategorias",
    permiso: 12,
    element: <SubCategoriasScreen />,
  },
  {
    path: "Global/Currency",
    permiso: 13,
    element: <CurrencyScreen />,
  },
  {
    path: "Global/Unit",
    permiso: 19,
    element: <UnitScreen />,
  },
  {
    path: "Global/TipoProducto",
    permiso: 20,
    element: <TipoProductoScreen />,
  },
  {
    path: "Global/Countries",
    permiso: 21,
    element: <CountriesScreen />,
  },
  {
    path: "Global/Types",
    permiso: 23,
    element: <TypesScreen />,
  },
  {
    path: "Global/Prioridades",
    permiso: 24,
    element: <PrioridadesScreen />,
  },
  {
    path: "Global/Areas",
    permiso: 28,
    element: <TabAreasScreen />,
  },
  {
    path: "Global/PermisosGenerales",
    permiso: 37,
    element: <PermisosGeneralesScreen />,
  },
  {
    path: "Global/Vehiculos",
    permiso: 65,
    element: <VehiculosScreen />,
  },
  {
    path: "Global/Motoristas",
    permiso: 66,
    element: <MotoristasScreen />,
  },
];

export default GlobalRouter;
